export default __webpack_public_path__ + "static/media/goshen51.815158f4.JPG";